import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { saveAs } from 'file-saver';
import { MatDialog, MatDialogRef } from '@angular/material';

import { DServicio, DRespuestaSimple, DContextoMuisca } from '@dian/core';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DBasicosParametricasServicios, DParametrosPolitica, DParametroPolitica, DValorDominio, DLugar } from '@dian/api-basicos-parametricas';
import { DReciboPago490Servicios, DLiquidacionRecibo, DRtaLiquidacionReciboPago, DConceptoLiquidacionRecibo, DListEntidadesBancarias, DEntidadBancaria, DDeudorSolidarioSubsidiario } from '@dian-api/recibo-pago490';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from './../servicios/doperaciones-matematicas.servicio';
import { DEnvioDataServicio } from './../servicios/denvio-data.servcio';
import { NotificationsService } from '../../../../services/notifications.service';
import { GeneralDialogComponent } from '../../../dialogos/general/general-dialog.component';
import { DialogsConfig } from '../../../../configuracion/dialog-views-data';
import { MessageObservableService } from '../../../../services/message-observable.service';
//import { EventEmitter } from 'events';

const optionsTabs = [
  { text: 'Generar recibo' },
  { text: 'Previsualizar' },
  { text: 'Datos de pago' }
];

@Component({
  selector: 'app-recibo-pago',
  templateUrl: './drecibo-pago.componente.html',
  styleUrls: ['./drecibo-pago.componente.css'],
  providers: [
    DReciboPago490Servicios,
    DBasicosParametricasServicios,
    DServicio,
    DatePipe
  ]
})
export class DReciboPagoComponente implements OnInit {

  public optionsTabs: any[] = optionsTabs;
  public indexSelectedTab: number = 0;

  public step: number = 1;
  public seleccion: string;
  public verMasInfo: boolean = false;


  public modeloConcepto: DConceptoLiquidacionRecibo;
  public fechaMinima: Date = new Date();
  public listCodigosTitulos: Array<DValorDominio>;
  public listDptos: Array<DLugar>;
  public listMpios: Array<DLugar>;
  public listEntidadesBancariasPSE: DListEntidadesBancarias;
  public listEntidadesBancariasCreditoEnLinea: DListEntidadesBancarias;
  public guardado: boolean = false;
  public reciboPago: DRtaLiquidacionReciboPago;
  public pagoVoluntario: string;
  public banco: DEntidadBancaria;
  public modeloDeudorSolidario: DDeudorSolidarioSubsidiario;
  public fechaPago: string;
  public innerHeight: number = window.innerHeight;
  //public browserName: string;
  public minFecha: Date = new Date();
  public stateInput: { error: boolean, message: string, dateString: string };
  public editandoImpuesto: boolean = false;
  public modeloinicial: DLiquidacionRecibo;


  // Se comentan estas variables para insertarlas como un input

  // public contextoUsuario: DContextoMuisca;
  // public tieneFirmaElectronica: boolean;
  // public modelo: DLiquidacionRecibo;
  // public mensajeAntesGuardar: string;
  // public usaPagoPSE: boolean;

  @Input() contextoUsuario: DContextoMuisca;
  @Input() tieneFirmaElectronica: boolean;
  @Input() modelo: DLiquidacionRecibo;
  @Input() fecha: string;
  @Input() mensajeAntesGuardar: string;
  @Input() usaPagoPSE: boolean = true;
  deudorSolidario = false;


  @Output() eventChangeModelo: EventEmitter<DRtaLiquidacionReciboPago> = new EventEmitter<DRtaLiquidacionReciboPago>();

  public disableCreditoLinea: boolean = true;
  public enableCodigoTitulo: boolean = false;
  public listCuotas: Array<number> = new Array<number>();


  private politica401: DParametrosPolitica;
  private numRepeticion: string;

  constructor(
    //private dialogRef: MatDialogRef<DReciboPagoComponente>,
    private dialog: MatDialog,
    private _servicioREST: DReciboPago490Servicios,
    private _servcioParametricasREST: DBasicosParametricasServicios,
    private dNotificacionServicio: DNotificacionServicio,
    private datePipe: DatePipe,
    private dutilidades: DOperacionesMatematicasServicio,
    private denvioData: DEnvioDataServicio,
    private _notifications: NotificationsService,
    private _messagesObs: MessageObservableService
  ) {
    this.contextoUsuario = new DContextoMuisca();
    this.modelo = new DLiquidacionRecibo();
    this.modeloConcepto = new DConceptoLiquidacionRecibo();
    this.listCodigosTitulos = new Array<DValorDominio>();
    this.listDptos = new Array<DLugar>();
    this.listMpios = new Array<DLugar>();
    this.banco = new DEntidadBancaria();
    this.modeloDeudorSolidario = new DDeudorSolidarioSubsidiario();
    this.listEntidadesBancariasPSE = new DListEntidadesBancarias();
    this.listEntidadesBancariasCreditoEnLinea = new DListEntidadesBancarias();
    this.reciboPago = new DRtaLiquidacionReciboPago();
    this.fechaPago = this.datePipe.transform(new Date(), 'yyyy/MM/dd', 'UTC-5');
    this.politica401 = new DParametrosPolitica();
  }

  ngOnInit() {
    if (this.modelo.conceptos && this.modelo.conceptos.length === 1) this.modeloConcepto = this.modelo.conceptos[0];
    setTimeout(() => {
      this.obtenerDatosParametricas();
      this.obtenerDepartamentos();
      this.obtenerBancosPagoEnLinea();
      this.construirListaCuotas();
      this.obtenerPolitica();


      this._messagesObs.sendMessages('recibo-pago-visualizar', {
        liquidacion: this.modelo,
        reciboPago: this.reciboPago
      });

      this._messagesObs.sendMessages('recibo-pago-guardado', this.guardado);
    }, 50);

    this.listenMessagesObs();
  }

  private listenMessagesObs() {
    this._messagesObs.getMessages().subscribe(res => {
      if (res.operation === 'calcular-intereses') {
        if (this.modelo.totalValorMonetario.impuesto && this.modelo.totalValorMonetario.impuesto != '0')
          this.calcularInteresRecibo();
      }

      if (res.operation === 'change-fechapago') {
        this.fechaPago = this.datePipe.transform(res.message, 'yyyy/MM/dd', 'UTC-5');
        this.calcularInteresRecibo();
      }
    });
    
    if(this.modeloinicial ==null)
      this.modeloinicial = JSON.parse(JSON.stringify(this.modelo));
      
  }

  public cambioFocoCasillas(e, el, remover?: boolean) {
    if (!remover)
      if (e.keyCode == 13) el.focus();
      else el.blur();
  }

  private construirListaCuotas() {
    if (Number(this.modelo.totalCuotas) > 1) {
      this.modelo.numCuota = null;
      for (let i = 1; i <= Number(this.modelo.totalCuotas); i++) {
        this.listCuotas.push(i);
      }
    }

    this._messagesObs.sendMessages('lista-cuotas-recibo-pago', this.listCuotas);
  }

  private obtenerDatosParametricas() {
    let preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this._servcioParametricasREST.obtenerValoresDominio('139')
      .subscribe(
        res => {
          this.listCodigosTitulos = <Array<DValorDominio>>res;
          preloader.close();
        },
        error => {
          this._notifications.showError('Error obteniendo datos de parametricas', error.descripcion);
          preloader.close();
        }
      );
  }

  public obtenerDepartamentos() {
    let preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this._servcioParametricasREST.obtenerDepartamentos()
      .subscribe(
        res => {
          this.listDptos = <Array<DLugar>>res;
          preloader.close();
        },
        error => {
          this._notifications.showError('Error obteniendo datos de parametricas', error.descripcion);
          preloader.close();
        }
      );
  }

  public obtenerCiudades() {
    const BOGOTADC = '11';
    const BOGOTADC_CIUDAD = '11001';

    let preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this._servcioParametricasREST.obtenerCiudades(null, this.modeloDeudorSolidario.departamento.codigo)
      .subscribe(
        res => {
          let listLocal = <Array<DLugar>>res;
          if (BOGOTADC === this.modeloDeudorSolidario.departamento.codigo) {
            this.listMpios = new Array<DLugar>();
            this.listMpios.push(listLocal[0]);
          } else this.listMpios = listLocal;
          preloader.close();
        },
        error => {
          this._notifications.showError('Error obteniendo datos de parametricas', error.descripcion);
          preloader.close();
        }
      );
  }

  private obtenerBancosPagoEnLinea() {
    let preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this._servicioREST.obtenerBancosPagoEnLineaPSE()
      .subscribe(
        res => {
          this.listEntidadesBancariasPSE = <DListEntidadesBancarias>res;
          preloader.close();
        },
        error => {
          this._notifications.showError('Error consultando los bancos para pago por PSE ', error.descripcion);
          preloader.close();
        }
      );
  }

  private obtenerBancosCreditoEnLinea() {
    if (!this.modeloConcepto['id']) {
      this._notifications.showInfo("Seleccione el concepto");
      this.guardado = false;
      this._messagesObs.sendMessages('recibo-pago-guardado', this.guardado);
      return;
    }

    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    this._servicioREST.obtenerBancosCreditoEnLinea(String(this.reciboPago.ideDocumento), this.modeloConcepto.id, this.modelo.fechaPago)
      .subscribe(
        res => {
          const listEntidadesBancarias = <DListEntidadesBancarias>res;
          listEntidadesBancarias.listEntidadesBancarias.forEach((item, index) => {
            if (!this.validarBancoCreditoEnLinea(item.codEntidadRecaudadora))
              listEntidadesBancarias.listEntidadesBancarias.splice(index, 1);
          });

          this.disableCreditoLinea = !listEntidadesBancarias.listEntidadesBancarias.length;
          this.listEntidadesBancariasCreditoEnLinea = listEntidadesBancarias;
          precarga.close();
        },
        error => {
          this._notifications.showError('Error consultando los bancos para credito en línea ', error.descripcion);
          precarga.close();
        }
      );
  }

  private validarBancoCreditoEnLinea(id: number): boolean {
    const parametros = this.obtenerParametro('BANCOS_PAGO_CREDITO_LINEA');
    const tipoUsuario = this.contextoUsuario.NitOrganizacion ? 'J' : 'N';
    const valores = parametros.valor.split(',');
    let bandera = false;

    if (!valores.length) return false;
    for (let i in valores) {
      const valor = valores[i].split('-');
      if (Number(valor[0]) === id) {
        if (valor[1] === tipoUsuario || valor[1] === 'A')
          bandera = true;
      }
    }
    return bandera;
  }

  public calcularInteresRecibo() {
    let preloader = this.dNotificacionServicio.mostrarDialogoCarga('Calculando Intereses');
    let modeloBorrador: DLiquidacionRecibo = this.obtenerModeloBorrador();

    this._servicioREST.calcularInteresRecibo(modeloBorrador)
      .subscribe(
        res => {
          let modeloRespuesta: DLiquidacionRecibo = <DLiquidacionRecibo>res;
          this.modelo.totalValorMonetario.interes = modeloRespuesta.totalValorMonetario.interes;
          //this._notifications.showInfo("Interes del recibo calculado.");
          this.calcularTotal();
          preloader.close();
        },
        error => {
          this._notifications.showError("Error calculando el interes del recibo de pago", error.descripcion);
          preloader.close();
        }
      );
  }

  public generarReciboPago() {
    if (!this.modeloConcepto['id'] || !this.modelo.numCuota || this.stateInput && this.stateInput.error) {
      this._notifications.showError('Revise los campos y diligéncielos de manera correcta');
    } else {
      if (this.mensajeAntesGuardar) {
        this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',this.mensajeAntesGuardar)
          .afterClosed()
          .subscribe(
            res => {
              if (!res) return;
              this.ejecutarGenerarReciboPago();
            }
          );
      } else this.ejecutarGenerarReciboPago();
    }
  }

  private ejecutarGenerarReciboPago() {
    if (this.modelo.totalValorMonetario.totalPagar == "0") {
      this._notifications.showInfo("Para generar el recibo este debe tener un valor a pagar");
      return;
    }

    let preloader = this.dNotificacionServicio.mostrarDialogoCarga('Generando Recibo');
    let modeloBorrador: DLiquidacionRecibo = this.obtenerModeloBorrador();

    this._servicioREST.generarReciboPago(modeloBorrador)
      .subscribe(
        res => {
          this.reciboPago = <DRtaLiquidacionReciboPago>res;
          this.eventChangeModelo.emit(this.reciboPago);
          //this.denvioData.enviarDataFormulario(this.reciboPago);
          this.guardado = true;
          this._messagesObs.sendMessages('recibo-pago-guardado', this.guardado);
          //this._notifications.showInfo('Recibo de pago generado');

          //Obtiene la lista de bancos para credito en linea una vez se ha guardado el documento
          const parametros = this.obtenerParametro('BANCOS_PAGO_CREDITO_LINEA');
          if (parametros.valor) this.obtenerBancosCreditoEnLinea();
          //this.denvioData.enviarCambiarFlujo('previsualizar');

          //Envio de datos al flujo del componente padre
          this.indexSelectedTab++;
          this._messagesObs.sendMessages('recibo-pago-visualizar', {
            liquidacion: this.modelo,
            reciboPago: this.reciboPago
          });
          this._messagesObs.sendMessages('490-position-tab', this.indexSelectedTab);
          preloader.close();
        },
        error => {
          this._notifications.showError('Error generando recibo de pago', error.descripcion);
          preloader.close();
        }
      );
  }

  private obtenerModeloBorrador() {
    this.modelo.fechaPago = this.fechaPago.replace(/\//g, '-');
    if (!this.modelo.codigoTitulo) delete this.modelo.codigoTitulo;
    let modeloBorrador: DLiquidacionRecibo = this.modelo;
    modeloBorrador.concepto = this.modeloConcepto;
    let sancion = this.dutilidades.redondearValorMoneda(this.modelo.totalValorMonetario.sancion, false);
    let interes = this.dutilidades.redondearValorMoneda(this.modelo.totalValorMonetario.interes, false);
    let impuesto = this.dutilidades.redondearValorMoneda(this.modelo.totalValorMonetario.impuesto, false);
    let totalPagar = this.dutilidades.redondearValorMoneda(this.modelo.totalValorMonetario.totalPagar, false);
    modeloBorrador.totalValorMonetario.sancion = this.dutilidades.deshacerFormatoMoneda(sancion);
    modeloBorrador.totalValorMonetario.interes = this.dutilidades.deshacerFormatoMoneda(interes);
    modeloBorrador.totalValorMonetario.impuesto = this.dutilidades.deshacerFormatoMoneda(impuesto);
    modeloBorrador.totalValorMonetario.totalPagar = this.dutilidades.deshacerFormatoMoneda(totalPagar);
    if (this.modeloDeudorSolidario.identificacion) modeloBorrador.deudor = this.modeloDeudorSolidario;
    return modeloBorrador;
  }

  public generarPDF() {
    let preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this._servicioREST.descargarPDFReciboPago(String(this.reciboPago.ideDocumento))
      .subscribe(
        res => {
          let descarga: DRespuestaSimple = new DRespuestaSimple();
          descarga = res;
          let mediaType = 'application/pdf';
          let blob = new Blob([descarga.blob], { type: mediaType });
          let filename = this.reciboPago.ideDocumento + '.pdf';
          saveAs(blob, filename);
          preloader.close();
        },
        error => {
          this._notifications.showError('Error generando PDF', error.descripcion);
          preloader.close();
        }
      );
  }

  public redireccionarPago(tipo: string) {
    if (!this.tieneFirmaElectronica) this.validarPolitica(tipo);
    else this.validarRedireccion(tipo);
    this.indexSelectedTab++;
    this._messagesObs.sendMessages('490-position-tab', this.indexSelectedTab);
  }

  private validarPolitica(tipo?: string) {
    const parametros = this.obtenerParametro('FORMATOS_EXCLUIDOS');
    let bandera = parametros && parametros.valor && (parametros.valor.indexOf(String(this.modelo.formato)) > -1);
    if (!bandera)
      this._notifications.showInfo('Para realizar pago electrónico la declaración debe estar presentada.');
    else this.validarRedireccion(tipo);
  }

  private obtenerPolitica() {
    let preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this._servcioParametricasREST.obtenerPolitica(401)
      .subscribe(
        res => {
          this.politica401 = <DParametrosPolitica>res;
          preloader.close();
        },
        error => {
          preloader.close();
          console.error("Error consultado la politica ", error);
          //this._notifications.showError('Error obteniendo la politica ', error.descripcion);
        }
      );
  }

  private obtenerParametro(parametro: string): DParametroPolitica {
    for (let item of this.politica401.parametros) {
      if (item.nombre === parametro) return item;
    }
    return null;
  }

  private validarRedireccion(tipo: string) {
    if (this.reciboPago.numRepeticion) {
      this.seleccion = tipo;
      this.denvioData.enviarCambiarFlujo('datosPago');
      if (tipo === 'PSE') {
        if (this.usaPagoPSE) this.step = 2;
        else
          window.open("/WebEntradasalida/DefInicioTransaccionPago.faces?numDocumento=" + this.reciboPago.ideDocumento + "&numRepeticion=" + this.reciboPago.numRepeticion + "", "", "width=700,height=400,scrollbars=yes,resizable=yes");
      }
      if (tipo === 'credito') this.step = 2;
    }
  }

  /*public redireccionarCreditoEnLinea() {
    if (!this.modeloConcepto.id) this._notifications.showError('Debe seleccionar un concepto');
    window.open("/WebCreditoEnLinea/credito-en-linea?numDocumento=" + this.reciboPago.ideDocumento + "&tipoImpuesto=" + this.modeloConcepto.id + "&fechaPago=" + this.modelo.fechaPago);
  }*/

  public redireccionarBanco() {
    if (!this.banco || !this.banco.urlEntidad) {
      this._notifications.showInfo("Por favor seleccione el banco");
      return;
    }

    if (this.seleccion === 'PSE') {
      let notificacion = this.dNotificacionServicio.mostrarDialogoConfirmacionPSE('Operación con entidad externa<br><br>Desde este momento abandonará el sitio web de la DIAN. Las transacciones que realice a continuación serán gestionadas directamente entre la Entidad Recaudadora y usted como cliente. A partir de este momento, la DIAN no tiene control sobre dichas operaciones. Ante cualquier inconveniente, por favor comuníquese con su entidad bancaria.');
      notificacion.afterClosed().subscribe(
        res => {
          if (!res) return;
          let params = (this.banco.urlEntidad.indexOf('?') > 0) ? '&' : '?';
          params = `${params}numReciboPago=${this.reciboPago.ideDocumento}&urlDian=${this.getEnvironment()}/WebEntradasalida/DefRespuestaTransaccionPago.faces`
          window.open(this.banco.urlEntidad + params, '_blank');
        }
      );  
      /*
      let params = (this.banco.urlEntidad.indexOf('?') > 0) ? '&' : '?';
      params = `${params}numReciboPago=${this.reciboPago.ideDocumento}&urlDian=${this.getEnvironment()}/WebEntradasalida/DefRespuestaTransaccionPago.faces`
      window.open(this.banco.urlEntidad + params, '_blank'); Esto era lo que estaba*/


      // this.dialog.open(GeneralDialogComponent, {
      //   disableClose: true,
      //   data: DialogsConfig.dialogoConfigRedirectPago
      // }).afterClosed().subscribe(res => {
      //   if (!res) return;
      //   let params = (this.banco.urlEntidad.indexOf('?') > 0) ? '&' : '?';
      //   params = `${params}numReciboPago=${this.reciboPago.ideDocumento}&urlDian=${this.getEnvironment()}/WebEntradasalida/DefRespuestaTransaccionPago.faces`
      //   window.open(this.banco.urlEntidad + params, '_blank');
      // });


      /*let notificacion = this.dNotificacionServicio.mostrarDialogoConfirmacion('Tenga en cuenta','Pago en proceso, será dirigido a A continuación ud va a salir de la DIAN y será redirigido a la pagina externa del banco, esta de acuerdo?');
      notificacion.afterClosed().subscribe(
        res => {
          if (!res) return;
          let params = (this.banco.urlEntidad.indexOf('?') > 0) ? '&' : '?';
          params = `${params}numReciboPago=${this.reciboPago.ideDocumento}&urlDian=${this.getEnvironment()}/WebEntradasalida/DefRespuestaTransaccionPago.faces`
          window.open(this.banco.urlEntidad + params, '_blank');
        }
      ); */


      
    }

    if (this.seleccion === 'credito') {
      window.open(this.banco.urlEntidad, '_blank');
      /*let mensaje = "Desde el momento en que usted haga clic en el bot&oacute;n 'Ir' ya no estar&aacute; en la DIAN. Las transacciones que realice a continuaci&oacute;n se llevan a cabo entre la Entidad Recaudadora y el cliente; a partir de este momento la DIAN no tiene el control de las mismas, ante cualquier inconveniente comun&iacute;quese con su banco.";
      let botonIr = { text: 'Ir', value: true, color: 'white', backgroundColor: '#069169', disabled: false };
      let buttonCancelar = { text: 'Cancelar', value: false, color: '#069169', backgroundColor: 'white', disabled: false };
      this.dNotificacionServicio.mostrarDialogoPersonalizado('Mensaje', mensaje, null, [botonIr, buttonCancelar], '#069169', 'white', false)
        .afterClosed().subscribe(
          res => {
            //if (res) window.location.href = url;
            if (!res) return;
            window.open(this.banco.urlEntidad, '_blank');
          }
        );*/
    }
  }

  /**
   * Function to close dialog
   * @param {Any} option selected
   */
  private closeDialog(option?: any) {
    // this.dialogRef.close(option);
  }

  public calcularTotal() {
    let campos = ['sancion', 'interes', 'impuesto'];
    let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, campos, true);
    let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma, "0") ? "0" : resultadoSuma;
    let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.totalValorMonetario.totalPagar = String(valorRedondeado);
    this.mostrarmensaje45();
  }

  public operarCamposCuerpo(operacion: DTipoOperacionAritmetica, campos: Array<string>, formatear: boolean): string {
    let valores = [];
    for (let i in campos) {
      if (this.dutilidades.validarValorNumerico(this.modelo.totalValorMonetario[campos[i]])) {
        let valor = this.dutilidades.redondearValorMoneda(this.modelo.totalValorMonetario[campos[i]]);
        valores.push(valor);
      } else {
        valores.push('0');
      }
    }
    return this.dutilidades.ejecutarOperacionMultipleValores(valores, operacion, formatear);
  }

  public getDate(dateString: string): Date {
    let splitDate = dateString.split('/');
    let date = new Date(Number(splitDate[0]), Number(splitDate[1]), Number(splitDate[2]));
    return date;
  }

  public getEventInputDateMask(event: { error: boolean, message: string, dateString: string }) {
    this.stateInput = event;
  }

  public getEnvironment(): string {
    return window.location.origin;
    /*if (window.location.origin.indexOf('dian') > -1)
      return 'https://muisca.dian.gov.co';
    else
      return 'https://pruebasfuncionales.dian.gov.co';*/
  }

  public checkTituloValue(value) {
    if (value) {
      const options = [
        { text: 'Si', value: true, backgroundColor: '#00bfa5b3', disabled: false },
        { text: 'No', value: false, disabled: false }
      ];
      this.dNotificacionServicio.mostrarDialogoPersonalizado("Señor usuario", "Esta casilla se diligencia ÚNICAMENTE si realiza el pago de sus impuestos con certificados o títulos o por los conceptos relacionados. Si utiliza otro concepto o medio de pago no la diligencie. ¿Está seguro de seleccionar esta opción?", null, options, null, null)
        .afterClosed().subscribe(res => {
          if (!res) this.modelo.codigoTitulo = null;
        });
    }
  }

  onFocusImpuesto() {
    this.editandoImpuesto = true;
  }

  onFocusOutImpuesto() {
    this.editandoImpuesto = false;
  }
  mostrarmensaje45()
  {
   
    if(this.modeloConcepto.id==='45')
    {
      this.modelo.totalValorMonetario.impuesto=this.modelo.aporteVoluntario;
      this.modelo.totalValorMonetario.totalPagar=this.modelo.aporteVoluntario;
    }
    else{
      this.modelo.totalValorMonetario.impuesto=this.modelo.impuestoconVoluntario;
      this.modelo.totalValorMonetario.totalPagar=this.modelo.totalConVoluntario;
    }
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/recibo-pago/src/componentes/drecibo-pago.componente.ts